<template>
  <div />
</template>

<script>
import EventBus from '@/eventbus.js'

var vm

export default {
  methods: {
    uploadFile (fileObj, emitText) {
      fileObj.uploadStatus = 1
      var formData = new FormData()
      formData.append('file', fileObj.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        },

        onUploadProgress: function (progressEvent) {
          var prog = progressEvent.loaded / progressEvent.total
          let perc = Math.ceil(prog * 100)
          if (perc > 100) {
            perc = 100
          }
          vm.$set(fileObj, 'uploadedSize', progressEvent.loaded)
          vm.$set(fileObj, 'fileSize', progressEvent.total)
          vm.$set(fileObj, 'uploadProgress', perc)
          EventBus.$emit('heyUploaderIDidSomething', fileObj)
        }
      }
      this.axios
        .post(fileObj.uploadUrl, formData, config)
        .then(function (response) {
          if (response.data.Success === true) {
            fileObj.uploadStatus = 2
            fileObj.resultURL = response.data.URL
            EventBus.$emit(emitText, fileObj)
          }
        })
        // eslint-disable-next-line
          .catch(function (error) {});
    }
  },

  mounted () {
    vm = this
    EventBus.$on('heyManagerUploadThisFile', this.uploadFile)
  },

  beforeDestroy () {
    EventBus.$off('heyManagerUploadThisFile')
  }
}
</script>

<style scoped></style>
